var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIconNav(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon_nav"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 49",
    opacity: 0.31,
    cx: 25,
    cy: 25,
    r: 25,
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Icon"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15C11 13.8954 11.8954 13 13 13H37C38.1046 13 39 13.8954 39 15C39 16.1046 38.1046 17 37 17H13C11.8954 17 11 16.1046 11 15Z",
    fill: "#30DDC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 25C11 23.8954 11.8954 23 13 23H37C38.1046 23 39 23.8954 39 25C39 26.1046 38.1046 27 37 27H13C11.8954 27 11 26.1046 11 25Z",
    fill: "#30DDC1"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 35C11 33.8954 11.8954 33 13 33H37C38.1046 33 39 33.8954 39 35C39 36.1046 38.1046 37 37 37H13C11.8954 37 11 36.1046 11 35Z",
    fill: "#30DDC1"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconNav);
export default __webpack_public_path__ + "static/media/icon_nav.b69b724cf66ea6570c50052b2537fcec.svg";
export { ForwardRef as ReactComponent };